import { render } from "./ProfileCard.vue?vue&type=template&id=2d6684f4&scoped=true"
const script = {}

import "./ProfileCard.vue?vue&type=style&index=0&id=2d6684f4&scoped=true&lang=css"

import exportComponent from "/Users/ken/Documents/Workspace/junipop/node_modules/.pnpm/vue-loader@17.0.1_vue@3.2.47_webpack@5.79.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6684f4"]])

export default __exports__